var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.spinning}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.l('EditTenantFeatures')))])]),_c('edition-feature-tree',{ref:"featureTree",attrs:{"editData":_vm.editData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }